export const internalError = {
  init: {
    monitoring: 'init(): Monitoring was not properly initialized',
    datadog: 'init(): Datadog was not properly initialized',
    heap: 'init(): Heap was not properly initialized'
  },
  createTimeEvent: {
    init: 'createTimeEvent(): Monitoring was not properly initialized',
    eventName: 'createTimeEvent(): Event name must be a string',
    time: 'createTimeEvent(): Time must be a number'
  },
  trackError: {
    errorObject: 'trackError(): Prop is not an instance of Error'
  },
  trackEvent: {
    eventName: 'trackEvent(): Event name must be a string'
  },
  trackPerformance: {
    init: 'trackPerformance(): Monitoring was not properly initialized',
    eventName: 'trackPerformance(): Event name must be a string',
    timeEvent: 'trackPerformance(): Time Event has not been created yet'
  }
};
